// extracted by mini-css-extract-plugin
module.exports = {"heading":"LargeTraitsHeading_heading__GGidm","noMobile":"LargeTraitsHeading_noMobile__iAEOv"};